var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIconFiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1_28033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE9\xA1\xB5\xE9\x9D\xA2-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "System"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete_2_line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6",
    d: "M21.4188 3C22.7101 3 23.8566 3.82629 24.2649 5.05131L25.0812 7.5H30C30.8284 7.5 31.5 8.17158 31.5 9C31.5 9.82841 30.8284 10.5 30 10.5L29.9963 10.6069L28.6952 28.8206C28.527 31.1756 26.5676 33 24.2067 33H11.7934C9.43248 33 7.473 31.1756 7.30479 28.8206L6.00381 10.6069C6.00125 10.571 5.99997 10.5354 5.99994 10.5C5.17153 10.5 4.5 9.82841 4.5 9C4.5 8.17158 5.17158 7.5 6 7.5H10.9189L11.7351 5.05131C12.1434 3.82629 13.2899 3 14.5811 3H21.4188ZM26.9963 10.5H9.00383L10.2972 28.6068C10.3532 29.3919 11.0064 30 11.7934 30H24.2067C24.9936 30 25.6467 29.3919 25.7028 28.6068L26.9963 10.5ZM15 15C15.7693 15 16.4033 15.579 16.4899 16.3251L16.5 16.5V24C16.5 24.8285 15.8285 25.5 15 25.5C14.2307 25.5 13.5967 24.921 13.5101 24.1749L13.5 24V16.5C13.5 15.6716 14.1716 15 15 15ZM21 15C21.8284 15 22.5 15.6716 22.5 16.5V24C22.5 24.8285 21.8284 25.5 21 25.5C20.1715 25.5 19.5 24.8285 19.5 24V16.5C19.5 15.6716 20.1715 15 21 15ZM21.4188 6H14.5811L14.0811 7.5H21.9189L21.4188 6Z",
    fill: "#F45045"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_28033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconFiles);
export default __webpack_public_path__ + "static/media/deleteIconFiles.5886d21917e3bc9867165b996dedc0e0.svg";
export { ForwardRef as ReactComponent };